import './pedidos.css';
import Navbar from "../navbar/navbar";
import { useState } from 'react';
import BuscaVazaia from '../components/buscavazia/buscaVazia';
import api from '../../services/api';
import { vhostV1, vhostV2 } from '../funcoes';
import { useEffect } from 'react';
import { Link,Navigate, useNavigate } from 'react-router-dom';
import { NumericFormat } from 'react-number-format';
import SweetAlert from 'react-bootstrap-sweetalert';
import ModalAdicaoItem from './modalAdicaoItem';
import { log } from 'react-modal/lib/helpers/ariaAppHider';
import Finalizadora from '../financeiro/Finalizadora/finalizadora';
import Card from './card';
import FooterBar from '../footer/footerBar';
import ModalCadastroCliente from './cadastroCliente';




function NovoPedido(){       
  
  
    const inputs = document.querySelectorAll("input, select, NumericFormat ,button ");
    // Adicione um manipulador de eventos para o evento "keydown" em cada entrada ou select
    inputs.forEach(input => {
      input.addEventListener("keydown", e => {
        // Se a tecla pressionada for Enter
        if (e.key === "Enter") {
          e.preventDefault(); // evita que a tecla "Enter" envie um formulário, se aplicável

          if (e.target.tagName.toLowerCase() === "button") {
            e.target.click(); // Dispara o evento de clique do botão
          } else {
          // Obtenha o índice do elemento atual
          const currentIndex = Array.from(inputs).indexOf(e.target);
  
          // Mova o foco para o próximo elemento de entrada ou select
          const nextIndex = currentIndex + 1;
          if (nextIndex < inputs.length) {
            inputs[nextIndex].focus();
          }
        }
      }
      });
    });

    const navigate = useNavigate();
   
   
   let config = {
      headers: {
        'Authorization': localStorage.getItem("token")
      }
    }

    let config2 = {
      headers: {
        'Authorization': localStorage.getItem("token2")
      }
    }
    
    var data = new Date();
    var dia = String(data.getDate()).padStart(2, '0');
    var mes = String(data.getMonth() + 1).padStart(2, '0');
    var ano = data.getFullYear();
    // setDataAtual = dia + '/' + mes + '/' + ano;

    
   const [dataAtual, setDataAtual] = useState(new Date());
   const [finalizadora, setFinalizadora] = useState([]);
   const [finalizadorasFiltradas, setFinalizadorasFiltradas] = useState([]);
   const [razao,setRazao] = useState('CADASTRO PADRÃO');
   const [buscaPessoa,setBuscaPessoa] = useState("");
   const [resultPessoa,setResultPessoa] = useState();
   const [pessoas,setPessoas] = useState();
   const [responsavel,setResponsavel] = useState();
   const [sResult,setSresult] = useState(0);
   const [confirmacao,setConfirmacao] = useState(false);
   const [confirmacaoId,setConfirmacaoID] = useState('');
   const [result, setResult] = useState(0);
   const [total,setTotal] = useState(0);
   const [Itens,setItens] = useState([]);
   const [idVenda,setIdVenda] = useState(0);
   const [totalPedido,setTotalPedido] = useState(0);
   const [sucesso,setSucesso]      = useState('N')
   const [mensagem, setMensagem]   = useState('');
   const [dataEmissao,setDataEmissao] = useState(new Date)
   const [formaPag,setFormaPag] = useState({codigo: 0,descricao: ''});
   const [recebebido,setRecebito] = useState(0);
   const [sucessoBusca,setSucessoBusca] = useState(false);
   const [produtos,setProdutos] = useState([]);
   const [buscaProduto,setBuscaProduto] = useState('');
   const [cliente,setCliente] = useState(0);
   const [vendedor, setVendedor] = useState(0);
   const [vendedorDesc, setVendedorDesc] = useState(localStorage.getItem('usuario'));
   const [gridProduto,setGridProduto] = useState(false);
   const [subTotal, setSubTotal] = useState(0);
   const [nr, setNr] = useState("");
   
   const [valorTotalPago, setValorTotalPago] = useState(0);
   const [pagamentos, setPagamentos] = useState([]);
   const [valorASerPago, setValorASerPago] = useState(totalPedido);
   const [pagamentosRealizados, setPagamentosRealizados] = useState([]);
   const [descricaoForma, setDescricaoForma] = useState('');
   const [confirmaPagamento, setConfirmaPagamento] = useState(false);
   const [autorizaFechamento, setAutorizaFechamento] = useState(false);
   const [navegar, setNavegar] = useState(false);
   const [key, setKey] = useState(0);
   const [load, setLoad] = useState(false);
   const [confirmaEmissao, setConfirmaEmissao] = useState(false);
   const [msgErro, setmsgErro] = useState('');
   const [erroEmissao, setErroEmissao] = useState(false);
   const [erroValidacao, setErrovalidacao] = useState(false);
   
   const [fantasia,setFantasia] = useState('');   
   const [cnpj,setCnpj] = useState('');
   const [inscEstadual,setEstadual] = useState('');
   const [inscMunicipal,setMunicipal] = useState('');
   const [endereco,setendereco] = useState('');
   const [bairro,setbairro] = useState('');
   const [cep,setcep] = useState('');
   const [cidade,setcidade] = useState('');
   const [fone,setfone] = useState('');
   const [uf,setuf] = useState('');
   const [desconto, setDesconto] = useState(0);
   const [descontoDefault, setDescontoDefault] = useState('');
   const [valorDescontado, setValorDescontado] = useState('');
   const [tipoDoc, setTipoDoc] = useState(0);
   const [numeroPedido, setNumeroPedido] = useState(0);
   const [pedidos, setPedidos] = useState([]);
   const [tipo,setTipo] = useState('TODOS');
   const [caixa,setCaixa] = useState('TODOS');  
   const [dataInical,setDataInicial] = useState(new Date()); 
   const [dataFinal,setDataFinal] = useState(new Date());
   const [totalComDesconto, setTotalComDesconto] = useState(0);
   const [campoVisivel, setCampoVisivel] = useState(true);
   const [isDisabled, setIsDisabled] = useState(true);
   const [dataAtualFormatada, setDataAtualFormatada] = useState('');
   const [nPag, setnPag] = useState(1);
   const [CpfCadastrado, setCpfcadastrado] = useState('');
   const [codcadastrado, setCodCadastro] = useState('');
   const [razaoCadastrado, setRazaoCadastrado] = useState('');
   const [nsu, setNsu] = useState('');
   const [escolhaNota, setEscolhaNota] = useState(false);
   const [notaCnpj, setNotaCnpj] = useState(false);
   const [notaCadPadrao, setNotaCadPadrao] = useState(false);
   const [confirmaVenda, setConfirmaVenda] = useState(false);
   const [bandeiraSelecionada, setBandeiraSelecionada] = useState('');
   const [redes,setRedes] = useState("");
   const [redeSelecionada, setRedeSelecionada] = useState('');
   const [pixAccessToken, setPixAccessToken] = useState('');
   const [busca, setBusca] = useState('');
   const [vendedores, setVendedores] = useState([]);
   const [codVendedor, setCodVendedor] = useState(0);
   const pixAcessKey = "UToblBcZB_D8CE2-yyU0pg";
   const pixSecretKey = "CnLV6It9ZDBn0qKZUuah6-gu3mYoo2Xya91-ZLUOqkZrE6fNLKCakr2_1reDHgTbnsCqP4qYT6PgnQLJYQkwFw";
   const pixClientId = "QYC9DMGQkmAOVyEVdvuQPrIKAqdYPiLu9j4s4hPrc_acya3xYNRyBNVaUzi47XxToCx6NBYkZIWyyM0i8vo3ccVjaA-YmbVaoCfkqJD8_Xv_3Owc1AY1-yPRHfnsmsrQHfrm8IjiiTXNlvgr3QWgQUYQO11Q3DeYaBw-y-EI6XU";   

   const [isNovoClienteOpen, setIsNovoClienteOpen] = useState(false);

const bandeiras = [
  { id: 1, descricao: "Visa" },
  { id: 2, descricao: "Mastercard" },
  { id: 3, descricao: "American Express" },
  { id: 4, descricao: "Sorocred" },
  { id: 5, descricao: "Diners Club" },
  { id: 6, descricao: "Elo" },
  { id: 7, descricao: "Hipercard" },
  { id: 8, descricao: "Aura" },
  { id: 9, descricao: "Cabal" },
  { id: 10, descricao: "Alelo" },
  { id: 11, descricao: "Banes Card" },
  { id: 12, descricao: "CalCard" },
  { id: 13, descricao: "Credz" },
  { id: 14, descricao: "Discover" },
  { id: 15, descricao: "GoodCard" },
  { id: 16, descricao: "GreenCard" },
  { id: 17, descricao: "Hiper" },
  { id: 18, descricao: "Jcb" },
  { id: 19, descricao: "MAis" },
  { id: 20, descricao: "MaxVan" },
  { id: 21, descricao: "Policard" },
  { id: 22, descricao: "RedCompras" },
  { id: 23, descricao: "Sodexo" },
  { id: 24, descricao: "ValeCard" },
  { id: 25, descricao: "Verocheque" },
  { id: 26, descricao: "VR" },
  { id: 27, descricao: "Ticket" },
  { id: 99, descricao: "Outros" }
];

useEffect(() => {
  api.post(vhostV1('webcash/vendas/listarBandeiras'),{},config)
  .then(function(response){
   console.log(response);
   setRedes(response.data.dados);
   
  }).catch(function(error){
    console.log(error);
    
  })
},[])

  

   const formatDate = (dateString) => {
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  };

  function converterParaInputDate(dataISO) {
    const data = new Date(dataISO);
    const ano = data.getFullYear();
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const dia = String(data.getDate()).padStart(2, '0');
    return `${ano}-${mes}-${dia}`;
  }

  useEffect(function(){
    setDataAtual(converterParaInputDate(dataAtual))
  },[])

  
  
  
   
 function AutShipay(){
   api.post(("https://api-staging.shipay.com.br/pdvauth"),{
    access_key: pixAcessKey,
    secret_key: pixSecretKey,
    client_id: pixClientId
   }).then(function(response){
    setPixAccessToken(response.data.access_token);

    
   }).catch(function(error){
    console.log(error);
   });
 }


 

   function confirmadeleteUser(id){
    setConfirmacaoID(id);
    setConfirmacao(true);
    
   }

   function deleteUser(id){
    api.post(vhostV1('webcash/vendas/cancelaItem'), {
      loja: localStorage.getItem('loja'),
      pedido:idVenda,
      item:id,
      empresa: 0        
    },config)
    .then(function (response) {
      console.log(response);
      
      setConfirmacao(false);
      retornaVenda();        
              
    })
    .catch(function (error) {
      console.log(error);
      setConfirmacao(false);
      
    });

}

const vendaSemNfce = async(npedido)=>{
  setLoad(true)
  const sJson = {}
    sJson.loja= localStorage.getItem('loja');
    sJson.empresa=0;
    sJson.id_orcamento=npedido;
    sJson.caixa='001';
    sJson.troco=troco;
          
     const res = await api.post(vhostV1('webcash/vendas/orcamentoxvenda'), sJson, config)  
    
   .then(function(response){
    console.log(response);
    setConfirmaVenda(true);
    // navigate('/app/listapedidos', { state: { reload: true } });
    // window.location.reload();
    
   }).catch((erro) => {
    setSucesso('N');
    console.log(erro);
    
   })
 
}
   
useEffect(() => {
  // Atualiza o valorASerPago se totalPedido mudar
  setValorASerPago(totalComDesconto.toString());
}, [totalComDesconto]);

const valorRestante = totalComDesconto - valorTotalPago;

useEffect(() => {
  setValorASerPago(valorRestante);
}, [valorTotalPago, totalComDesconto]);


function fecharVenda(){
  setAutorizaFechamento(false);
  api.post(vhostV1('webcash/vendas/fecharDav'), {
    iPedido: Number(idVenda),
    tipo: 1,
    data: dataAtual,
    doc: tipoDoc,   
    troco: troco     
  },config)
  .then(function(response){
    
    
    setMensagem('');
    //setSucesso('S');
    setConfirmaPagamento(false);
    if(tipoDoc > 0 && cnpj.length === 11){
      console.log("entrei no cpf");
      setEscolhaNota(true);
    }else if(tipoDoc > 0 && cnpj.length === 0){
      console.log("entrei no padrao");
      
      setNotaCadPadrao(true);
    }else if(tipoDoc > 0 && cnpj.length > 11){
      console.log("entrei no cnpj");
      setNotaCnpj(true);
    }else{vendaSemNfce(numeroPedido);
      console.log('Vendi sem NFCe');
      
    }
    
    console.log()
    
    

}).catch((erro) =>{
    setMensagem(erro);
    setSucesso('N');
    setConfirmaPagamento(false);
});

}

    
    


    async function EmitirNFCe () { 

      const tItens = await enviarNFce();
    
      console.log(tItens);
        
    }

     
     
   
    const enviarNFce = async(npedido,tipo)=>{
      setLoad(true)
      const sJson = {}
        sJson.loja=localStorage.getItem('loja'); 
        sJson.empresa=0;
        sJson.dav=String(npedido);
        sJson.tipo=tipo;
        sJson.tag=1;
        console.log(sJson);
        
              
         const res = await api.post(vhostV1('webcash/nfe/emitir/nfe'), sJson, config) 
         console.log(res);
          
        
        if (res.status===200) {      
         setConfirmaEmissao(true) 
         setLoad(false)
         
        }else {
          setLoad(false)
          console.log(res);
          
          setmsgErro(res.response.data.erro);
          setErroEmissao(true)
          
        }      
     
    }
    

    
   useEffect(function(){
    
    api.get(vhostV1('webcash/finalizadoras/ListaFinalizadoras'), config)
      .then(function (response) {
          if (response && response.data && response.data.dados){
            const dados = response.data.dados;
            setFinalizadora(dados);
          
            const filtradas = dados.filter(forma => forma.COD_FINALIZADORA <= 90);
          setFinalizadorasFiltradas(filtradas); 
          console.log(response.data.dados)
          setResult(1);
        }else{
          setResult(0);
        }       
      })
      .catch(function (error) {
        console.log(error);
                
      });

      
  },[])

  useEffect(() => {
  
    if (tipoDoc) {
      const filtradas = finalizadora.filter(
        forma => forma.TIPO_DOC === tipoDoc && forma.COD_FINALIZADORA <= 90
      );
      setFinalizadorasFiltradas(filtradas);
    }
  }, [tipoDoc, finalizadora]);


  useEffect(() => {
    setTotalComDesconto(Number(totalPedido-desconto))
   }, [totalPedido, desconto])


   function retornaVenda(){
      api.post(vhostV1('webcash/vendas/retornaVenda/'+idVenda),{codOrcamento: Number(idVenda)},config)
       .then(function (response) {
        console.log(response);
        
        const dados = response.data.dados;
          setTotalPedido(dados.TOTAL);
          setNumeroPedido(dados.COD_ORCAMENTO);
          setResponsavel(dados.RESPONSAVEL);
          setDesconto(dados.DESCONTO);
          console.log(dados);
            if(dados.itens.length > 0){
              setItens(dados.itens);     

            } else {
              setItens([]);
            }
             
       

                  
       })
       .catch(function (error) {
        
         console.log(error);

                 
       });
    }

    const totalDesconto = Itens.reduce((acc, item) => acc + item.DESCONTO, 0);
  

    const valorNota = totalPedido;

    const formatCurrency = (value) => {
      return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    };
    
    const [isAdicaoOpen,setIsAdicaoOpen] = useState(false);

    function openModalAdicao(){
       setIsAdicaoOpen(true)
    }

   async function closeModalAdicao(){
     retornaVenda();   
     setIsAdicaoOpen(false)        
    }
      const handleChange = (e) => {
      const selectedValue = e.target.value;
      const selectedOption = finalizadorasFiltradas.find(forma => forma.DESCRICAO === selectedValue);
  
      if (selectedOption) {
        setDescricaoForma(selectedValue);
        setFormaPag({
          descricao: selectedValue,
          codigo: selectedOption.COD_FINALIZADORA
        });
        setTipoDoc(selectedOption.TIPO_DOC); 
      }
    };

    function listaPessoaCad(){
      
      api.post(vhostV1('webcash/cadastro'), {
          loja: localStorage.getItem('loja'),
          empresa: 0,
          tipo:"C",
          busca: CpfCadastrado,
          pagina: nPag,
          regPag: 10,
        },config)
        .then(function (response) {
          setCodCadastro(response.data.dados[0].COD_CADASTRO);  
          setRazaoCadastrado(response.data.dados[0].RAZAO);
          console.log(response);                                  
                   
        })
        .catch(function (error) {
         
          console.log(error);
  
                  
        });
      }

    function openModalAddCliente(){
      setIsNovoClienteOpen(true);
    }

    function closeModalNovoCliente(){
      
      listaPessoaCad();
     setIsNovoClienteOpen(false);
    
     console.log(CpfCadastrado);
     
     if(CpfCadastrado !== '' && CpfCadastrado !== null){
      pesquisaPessoa(CpfCadastrado);
     }
     
    }


    const gravaRecebimentos = () => {
      console.log(pagamentos);
      
      pagamentos.forEach((pagamento) => {
        gravaRecDav(
          pagamento.valor,              
          pagamento.formaPagamento,      
          pagamento.codigoFinalizadora   
        );      
        
        
        
          
      
     setConfirmaPagamento(true);
      })};
    
      const registrarPagamento = () => {
        if (formaPag.codigo === 0 || formaPag.codigo === null) {
          setmsgErro("Selecione uma forma de pagamento");
          setErrovalidacao(true);
        } else {
          const valorPagar = parseFloat(`${valorASerPago}`.replace('.', ',').replace(',', '.'));
          const valorSobra = parseFloat(`${valorRestante}`.replace('.', ',').replace(',', '.'));
          
          if (valorPagar > 0 && valorPagar <= valorSobra) {
            // Atualizar o estado de pagamentos
            const novoPagamento = {
              formaPagamento: formaPag.descricao,
              valor: valorPagar,
              codigoFinalizadora: formaPag.codigo
            };
      
            // Atualizar a lista de pagamentos
            setPagamentos(prevPagamentos => {
              return [...prevPagamentos, novoPagamento];
            });
      
            // Atualizar o valor total pago
            setValorTotalPago(prevValor => prevValor + valorPagar);
      
            // Atualizar a lista de pagamentos realizados
            setPagamentosRealizados(prevPagamentosRealizados => {
              const index = prevPagamentosRealizados.length;
      
              const pagamentoRealizadoAtualizado = {
                ...(prevPagamentosRealizados[index] || {}),
                valor: (prevPagamentosRealizados[index]?.valor || 0) + valorPagar
              };
      
              const novosPagamentosRealizados = [...prevPagamentosRealizados];
              novosPagamentosRealizados[index] = pagamentoRealizadoAtualizado;
      
              return novosPagamentosRealizados;
            });
      
            setValorASerPago(valorRestante.toFixed(2).replace('.', ','));
      
            
            if (valorTotalPago >= totalComDesconto) {
              calcularTroco(); 
            }
          } 
          
          else if (valorPagar >= valorSobra) {

          
            
            
            
            const pagamento = {
              formaPagamento: formaPag.descricao,
              valor:valorSobra, 
              codigoFinalizadora: formaPag.codigo
            };
          
            // Atualizar a lista de pagamentos
            setPagamentos(prevPagamentos => {
              return [...prevPagamentos, pagamento];
            });
          
            // Atualizar o valor total pago
            setValorTotalPago(prevValor => prevValor + pagamento.valor);
          
            // Atualizar a lista de pagamentos realizados
            setPagamentosRealizados(prevPagamentosRealizados => {
              const index = prevPagamentosRealizados.length;
              const pagamentoRealizadoAtualizado = {
                ...(prevPagamentosRealizados[index] || {}),
                valor: (prevPagamentosRealizados[index]?.valor || 0) + pagamento.valor
              };
          
              const novosPagamentosRealizados = [...prevPagamentosRealizados];
              novosPagamentosRealizados[index] = pagamentoRealizadoAtualizado;
          
              return novosPagamentosRealizados;
            });
          
            // Atualizar o valor a ser pago para o valor restante
            setValorASerPago((valorRestante - pagamento.valor).toFixed(2).replace('.', ','));
      
            // Chamar a função calcularTroco para calcular o troco, pois o pagamento excedeu o valorRestante
            setTroco(valorPagar - valorSobra);
            
            
            gravaRecebimentos();
          } 
          else {
            console.log('Valor inválido ou excede o valor restante.');
          }
        }
      };
      
    const [troco, setTroco] = useState(0);
    
    

    const calcularTroco = () => {
      const valorPagar = parseFloat(valorASerPago.replace('.', ',').replace(',', '.'));
      const calculo = valorPagar - valorRestante;
      console.log(calculo);
      
      
      if (calculo >= 0) {
        setTroco(calculo);        
        
        
        } else {
        alert('Valor insuficiente para completar o pagamento.');
      }
    };

    const resetarValores = () => {
      setFormaPag('');
      setValorTotalPago(0);
      setPagamentos([]);
      setPagamentosRealizados([]);
      setValorASerPago(totalComDesconto);
    };


  function fecharTelaVenda(){
    setConfirmaEmissao(false)
    
    //setSucesso('S');
    navigate('/app/listapedidos', { state: { reload: true } });
    window.location.reload();
    
   
  }  

  useEffect(() => {
    if (valorRestante <= 0) {
      setCampoVisivel(false);     
    } else {
      setCampoVisivel(true);
    }
   }, [valorRestante])

  

  
     

  
   function gravaRecDav( valorRecebido,descricaoPagamento, finalizadoraCod){
                     
    api.post(vhostV1('webcash/vendas/gravarRecDav'),{
      loja: Number(localStorage.getItem('loja')),
      empresa:0,
      seq:1,
      idOrcamento:idVenda,
      data: '',       
      hora :'',      
      sValor: valorRecebido,     
      nsu: nsu.length > 0 ? nsu : "000000",        
      autorizacao:'000000',
      rede:'0000',
      produto: descricaoPagamento,
      logico:'000000',
      tipo: descricaoPagamento,       
      nrParcelas:1, 
      cnpjAdquirente:'00000000000',
      idRemoto:1,
      codFinalizadora: finalizadoraCod,
      
     },config)
     .then(function (response) {
       console.log(response);
       
       setRecebito(1); 
          
       
      ;                  
                   
                
     })
     .catch(function (error) {
      setRecebito(0);                                   
       console.log(error);

               
     });


  }

  useEffect(() => {
    // Verifica se a loja é igual a '12' e define o estado inicial
    const loja = localStorage.getItem('loja');
    if(Number(loja) === 12){
       setIsDisabled(false);
    }
    
  }, []);


  function adicionaCliente(e){
   
    api.post(vhostV1('webcash/vendas/adicionaCliente'), {
      cod_orcamento:Number(idVenda),
      cliente:Number(e),
      tipo:"P"
     },config)
     .then(function (response) {
       
       console.log(response);                               
                
     })
     .catch(function (error) {
      setRecebito(0);                                   
       console.log(error);

               
     });


 }
   
   function listaPessoa(e){
      e.preventDefault();
      api.post(vhostV1('webcash/cadastro/'), {
          loja: localStorage.getItem('loja'),
          empresa: 0,
          tipo:"",
          busca: buscaPessoa,
          pagina: nPag,
          regPag: 10,
        },config)
        .then(function (response) {
          setPessoas(response.data.dados);  
          setResultPessoa(response.data.result);
          console.log(response);                                  
                   
        })
        .catch(function (error) {
         
          console.log(error);
  
                  
        });
      }
  
  
      function pesquisaPessoa(e){
        console.log(e);
        
                
      api.post(vhostV1('webcash/cadastro/'+e), {
          loja: localStorage.getItem('loja'),
          empresa: 0,
        },config)
        .then(function (response) {
          console.log(response);
          adicionaCliente(e); 
          console.log(response.data.dados.cadastro.COD_CADASTRO)
          setRazao(response.data.dados.cadastro.RAZAO); 
          setCnpj(response.data.dados.cadastro.CNPJ);
          setFantasia(response.data.dados.cadastro.FANTASIA); 
          setbairro(response.data.dados.cadastro.BAIRRO);
          setcidade(response.data.dados.cadastro.CIDADE);
          setuf(response.data.dados.cadastro.ESTADO);
          setfone(response.data.dados.cadastro.TELEFONE); 
          setcep(response.data.dados.cadastro.CEP);
          setMunicipal(response.data.dados.cadastro.MUNICIPAL);
          setEstadual(response.data.dados.cadastro.ESTADUAL);
          setendereco(response.data.dados.cadastro.ENDERECO);
          setNr(response.data.dados.cadastro.NREND1);


                   
        })
        .catch(function (error) {
         
          console.log(error);
  
                  
        });
                
      }

       useEffect(function(){
          
            api.post(vhostV1('webcash/colaborador/listarVendedor'), {
                loja: localStorage.getItem('loja'),
                empresa: 0,
                busca: busca,
                pagina: 1,
                regPag: 100,
                inativo: false
              },config)
              .then(function (response) {
                console.log(response);
                
           
                  setVendedores(response.data.dados); 
                         
              })
              .catch(function (error) {
                console.log(error);
                        
              });
        
              
          },[busca])
      
    
      useEffect(function(){
        
         api.post(vhostV1('webcash/vendas/iniciarVenda'), {
            empresa:0,
            idMesa: 1,
            codigoColaborador: Number(localStorage.getItem("colaborador")),
            quantidadePessoas: 1,
            nome: "",
            caixa: "001",
            codIndicado: ""
           },config)
           .then(function (response) {
            
            console.log(response);
            
            
              
              
              setIdVenda(response.data.codigoOrcamento); 
              
              
             }                               
           )
           .catch(function (error) {
             console.log(error);
                     
           });    
           
       },[])

       useEffect(() => {
        const handleKeyPress = (event) => {
          switch (event.key) {
            case "F1":
              event.preventDefault();
              document.getElementById("btn-pesquisar-cliente")?.click();
             
              break;
            case "F2":
              event.preventDefault();
              setIsAdicaoOpen(true);
              break;
            case "F3":
              event.preventDefault();
              navigate("/app/listapedidos");
              break;
            case "F4":
              event.preventDefault();
              document.getElementById("btn-finalizar")?.click();
              break;
            default:
              break;
          }
        };
    
        document.addEventListener("keydown", handleKeyPress);
        return () => {
          document.removeEventListener("keydown", handleKeyPress);
        };
      }, [navigate]);

     function attCodColaborador(e) {
  api.post(
    vhostV1('webcash/vendas/attColaboradorOrcamento'),
    {
      cod_orcamento: Number(idVenda),
      cod_colaborador: Number(e),
    },
    config
  )
  .then(function (response) {
    console.log(response);
  })
  .catch(function (error) {
    console.log(error);
  });
}

      useEffect(() => {
        // Seleciona o modal
        const modal = document.getElementById('staticBackdrop');
        
        // Adiciona o evento de quando o modal for aberto
        modal.addEventListener('shown.bs.modal', () => {
          // Dá o foco ao campo de entrada
          document.getElementById('campo-pesquisa-cliente').focus();
        });
      
        return () => {
          // Limpa o evento ao desmontar o componente
          modal.removeEventListener('shown.bs.modal', () => {});
        };
      }, []);

      const handleSelecionarVendedor = (v) => {
  setVendedor(v.ID);
  setVendedorDesc(v.NOME);
  attCodColaborador(v.ID);
};

   return <div className="conteiner-fluid titulo ">
   <Navbar/>

   <ModalAdicaoItem isOpen={isAdicaoOpen}
                 onRequestClose={closeModalAdicao}
                 idVenda={idVenda}
                 setIsAdicaoOpen={setIsAdicaoOpen}
                 titulo="Adicionar Item "
                
                 
                 />   

    <ModalCadastroCliente isOpen={isNovoClienteOpen}
                         onRequestClose={closeModalNovoCliente} 
                         setCodCadastro={setCpfcadastrado}
                         
                         
    />             


   
   <div className="offset-2 col-8">
         <div className='d-flex justify-content-between'>
           <h4>Novo pedido</h4> 
         <h5>{localStorage.getItem("usuario").toLocaleUpperCase()}</h5>
         </div>
        

         <hr />
          <div className="conteiner-fluid">
          <form className="row tela">
             
             <div className="col-2">
                 <label htmlFor="inputAddress" className="form-label">N PEDIDO</label>
                 <input type="text" value={idVenda} className="form-control" id="inputCodigo" tabIndex="1" required autoComplete="off"/>
             </div>

            <div className="col-md-4">
  <label htmlFor="inputVendedor" className="form-label">VENDEDOR</label>
  <div className="input-group mb-3">
    <input 
      type="text"  
      value={vendedorDesc}  
      onChange={(e)=> setVendedor(e.target.value)} 
      className="form-control" 
      id="inputVendedor" 
      autoComplete="off"
      disabled
    />
    <button 
      type="button" 
      className="btn btn-secondary" 
      data-bs-toggle="modal" 
      data-bs-target="#modalVendedor"
    >
      Pesquisar
    </button>
  </div>

  {/* MODAL DE VENDEDORES */}
  <div className="modal fade mt-5" id="modalVendedor" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="modalVendedorLabel" aria-hidden="true">
    <div className="modal-dialog modal-lg">
      <div className="modal-content">
        <div className="modal-header">
          <h1 className="modal-title fs-5" id="modalVendedorLabel">Pesquisa de Vendedores</h1>
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div className="modal-body">
          {/* CAMPO DE PESQUISA */}
          <div className="input-group mb-3">
            <input 
              type="text" 
              className="form-control" 
              placeholder="Digite sua pesquisa" 
              onChange={(e) => setBusca(e.target.value)} 
            />
            <button 
              className="btn btn-primary" 
              type="button"
            >
              <i className="fas fa-search"></i> Pesquisar
            </button>
          </div>

          {/* TABELA DE RESULTADOS */}
          <table className="table table-hover table-striped">
            <thead>
              <tr>
                <th scope="col">ID</th>
                <th scope="col">Nome</th>
                <th scope="col">Função</th>
                <th scope="col">Ação</th>
              </tr>
            </thead>
            <tbody className="table-group-divider">
              {vendedores && vendedores.length > 0 ? vendedores.map((vendedorObj) => (
                <tr key={vendedorObj.ID}>
                  <td>{vendedorObj.ID}</td>
                  <td>{vendedorObj.NOME}</td>
                  <td>{vendedorObj.FUNCAO}</td>
                  <td>
                    <a 
                      href="#" 
                      onClick={(e) => {
                      e.preventDefault();
                     handleSelecionarVendedor(vendedorObj);
  }}
                      data-bs-dismiss="modal"
                    >
                      <i className="bi bi-file-arrow-down-fill"></i>
                    </a>
                  </td>
                </tr>
              )) : (
                <tr>
                  <td colSpan="4" className="text-center">Nenhum vendedor encontrado</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
 
      </div>
    </div>
  </div>
</div>

             <div className="col-3">
                 <label htmlFor="inputAddress" className="form-label">DATA</label>
                 <input type="date"  value={dataAtual} onChange={(e) => setDataAtual(e.target.value)} className="form-control" disabled={isDisabled}/>
             </div>

             <div className="col-3">
                 <label htmlFor="inputAddress" className="form-label">TOTAL</label>
                  <NumericFormat className="form-control"
                                      id="inputValorTotal" 
                                      value={totalComDesconto.toLocaleString("pt-br", {style:"currency", currency:"BRL"})}
                                      tabIndex="9"
                                      allowLeadingZeros
                                      decimalSeparator=','
                                      thousandSeparator='.'
                                      decimalScale={2}
                                      prefix="R$ "
                                      
                                 />  
             </div>
              
             <div className="col-md-12">
                       <label htmlFor="inputCity" className="form-label">CLIENTE</label>
                        <div className="input-group mb-3">
                           <input type="text"  value={razao} className="form-control" id="inputNcm" tabIndex="7" disabled/>
                           <button className="btn-primary"  onClick={openModalAddCliente} type="button" ><i className="bi bi-plus-circle-fill"></i></button>
                            <button id="btn-pesquisar-cliente" type="button" className="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
                            Pesquisar (F1)
                            </button>
                        </div>

                        <div className="modal fade mt-5" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false"  aria-labelledby="staticBackdropLabel" aria-hidden="true">
                         <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                            <div className="modal-header">
                                <h1 className="modal-title fs-5" id="staticBackdropLabel">Pesquisa Cadastro</h1>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div >
                                <div className="input-group mb-3">
                                  <input onChange={(e) => setBuscaPessoa(e.target.value)} tabIndex="15" type="text" className="form-control" id="campo-pesquisa-cliente" placeholder="Digite sua pesquisa" aria-describedby="button-addon2" autoFocus/>
                                  <button onClick={listaPessoa} className="btn btn-primary" tabIndex="16" type="button" id="button-addon2"><i className="fas fa-search"></i> Pesquisar</button>
                                </div>
                               
                                { resultPessoa === 1?
                                <table className="table table-hover table-striped">
                                <thead>
                                <tr>
                                    <th scope="col">Codigo</th>
                                    <th scope="col">Razão</th>
                                    <th scope="col">Ação</th>
                                    </tr>
                                </thead>
                                <tbody className="table-group-divider">
                                { pessoas.map((pessoa)=> {
                                    return <tr key={pessoa.COD_CADASTRO}>
                                        <td>{pessoa.CNPJ}</td>          
                                        <td>{pessoa.RAZAO}</td>
                                        <td>
                                          <button onClick={()=> pesquisaPessoa(pessoa.COD_CADASTRO)} value={pessoa.RAZAO} >
                                            <i className="bi bi-file-arrow-down-fill" data-bs-dismiss="modal"></i>
                                          </button>                                        
                                        </td>
                                    </tr>
                                } )}  
                                </tbody>
                            </table>:<BuscaVazaia/>}   

                                </div>
                            </div>
                            <div className="modal-footer">
                                
                            </div>
                            </div>
                        </div>
                        </div>
                        
                      </div>
                      <div className="accordion accordion-flush mb-2" id="accordionExample">
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                           <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                            DADOS DO DESTINATÁRIO
                          </button>
                        </h2>
                        <div id="collapseOne" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                          <div className="accordion-body"></div>

                      <div className="row">
                       
                        <div className="col-8">
                            <label htmlFor="inputAddress" className="form-label">FANTASIA</label>
                            <input type="text"  value={fantasia} className="form-control" id="inputCodigo" tabIndex="1" required autoComplete="off"/>
                        </div>
                        <div className="col-4">
                            <label htmlFor="inputAddress" className="form-label">CNPJ/CPF</label>
                            <input type="text" value={cnpj} className="form-control" id="inputCodigo" tabIndex="1" required autoComplete="off"/>
                        </div>
                        <div className="col-2">
                            <label htmlFor="inputAddress" className="form-label">CEP</label>
                            <input type="text" value={cep} className="form-control" id="inputCodigo" tabIndex="1" required autoComplete="off"/>
                        </div>
                        <div className="col-1">
                            <label htmlFor="inputAddress" className="form-label">UF</label>
                            <input type="text" value={uf} className="form-control" id="inputCodigo" tabIndex="1" required autoComplete="off"/>
                        </div>
                        <div className="col-4">
                            <label htmlFor="inputAddress" className="form-label">CIDADE</label>
                            <input type="text" value={cidade} className="form-control" id="inputCodigo" tabIndex="1" required autoComplete="off"/>
                        </div>
                        <div className="col-1">
                            <label htmlFor="inputAddress" className="form-label">Nº</label>
                            <input type="text" value={nr} className="form-control" id="inputCodigo" tabIndex="1" required autoComplete="off"/>
                        </div>
                        <div className="col-2">
                            <label htmlFor="inputAddress" className="form-label">INSC EST</label>
                            <input type="text" value={inscEstadual} className="form-control" id="inputCodigo" tabIndex="1" required autoComplete="off"/>
                        </div>
                        <div className="col-2">
                            <label htmlFor="inputAddress" className="form-label">INSC MUN</label>
                            <input type="text" value={inscMunicipal} className="form-control" id="inputCodigo" tabIndex="1" required autoComplete="off"/>
                        </div>
                        <div className="col-3">
                            <label htmlFor="inputAddress" className="form-label">BAIRRO</label>
                            <input type="text" value={bairro} className="form-control" id="inputCodigo" tabIndex="1" required autoComplete="off"/>
                        </div>


                        <div className="col-7">
                            <label htmlFor="inputAddress" className="form-label">ENDEREÇO</label>
                            <input type="text" value={endereco} className="form-control" id="inputCodigo" tabIndex="1" required autoComplete="off"/>
                        </div>
                        <div className="col-2">
                            <label htmlFor="inputAddress" className="form-label">FONE</label>
                            <input type="text" value={fone} className="form-control" id="inputCodigo" tabIndex="1" required autoComplete="off"/>
                        </div>




                      </div>
                      
                      </div>
                    </div>
                  </div>

                  
             <br />
             <hr />
             <h4>Itens do Pedido</h4>
             <hr />
             <div className="col-4">
               <button className="btn btn-success btn-cli" onClick={openModalAdicao} type="button" ><i className="bi bi-upc"></i>Adicionar (F2)</button>
             </div>
                       
           </form>

           <table className="table table-hover table-striped">
            <thead>
            <tr>
                <th scope="col">Codigo</th>
                <th scope="col">Descricao</th>
                <th scope="col">Qtd</th>
                <th scope="col">Venda</th>
                <th scope="col">Desconto</th>
                <th scope="col">Total</th>
                <th scope="col">Ação</th>

                
                </tr>
            </thead>
            <tbody className="table-group-divider">
              {Itens.length > 0?  
                 Itens.map((item,i)=> {
                  return <tr key={item.ITEM}>
                      <td>{item.COD_PRODUTO}</td>          
                      <td>{item.DESCRICAO}</td>
                      <td>{Number(item.QTD).toFixed(3)}</td>
                      <td>{new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(item.VENDA)}</td>
                      <td>{new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(item.DESCONTO)}</td>
                      <td>{new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(item.TOTAL)}</td>
                      <td><button onClick={() => confirmadeleteUser(item.ITEM)} className="dropdown-item"><i className="bi bi-trash-fill"></i></button></td> 
                  </tr>
              } ):null}  
            </tbody>
          </table>
           
         </div>    
         
         <div className='mb-5'>
         <Link to="/app/listapedidos" type="submit" className="btn btn-outline-primary butao"  tabIndex="14">Desistir (F3)</Link>
         {/*<button type="submit" onClick={fecharVenda} className="btn btn-primary butao" tabIndex="13">Salvar</button>*/}
        
          <button id="btn-finalizar" type="button" className="btn btn-primary butao" data-bs-toggle="modal" data-bs-target="#exampleModal">
            Finalizar (F4)
          </button>
          </div>

      <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="exampleModalLabel">Recebimento</h1>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
          <div className="d-flex justify-content-between align-items-end p-3">
      <Card title="Sub-total" style={{borderLeft: 'solid 5px #FFA500'}} value={Number(valorNota).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} />
      <Card title="Desconto" style={{borderLeft: 'solid 5px #dc3545'}}  value={Number(totalDesconto).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} />
      <Card title="Valor" style={{borderLeft: 'solid 5px #28a745'}} value={Number(valorRestante).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} />
         </div>
            
            <br />
            <div className="row mb-3">
              <select
                onChange={handleChange}
                value={formaPag.descricao}
                className="form-select form-select-lg mb-3"
                aria-label=".form-select-lg example"
              >
               <option value="">Selecione a forma de pagamento</option> 
                {finalizadorasFiltradas.map((forma) => (
                  <option key={forma.COD_FINALIZADORA} value={forma.DESCRICAO}>
                    {forma.COD_FINALIZADORA} - {forma.DESCRICAO}
                  </option>
                ))}
              </select>
            </div>

            {formaPag.codigo === 2 ? (
              <div className="row">
                <div className="col-4">
                  <label htmlFor="inputCnpj" className="form-label">CNPJ ADQUIRENTE</label>
                  <input type="text" className="form-control" id="inputCnpj" tabIndex="1" required autoComplete="off" />
                </div>
                <div className="col-6">
                  <label htmlFor="inputAutorizacao" className="form-label">NÚMERO AUTORIZAÇÃO</label>
                  <input type="text" className="form-control" id="inputAutorizacao" tabIndex="1" />
                </div>
              </div>
            ) : null}
             {formaPag.codigo === 3 ? (
              <div className="row">
                <div className='col-4'>
                  <label htmlFor="" className='form-label'>FORMA:</label>
                  <select className="form-select form-select-lg mb-3" id="inputCartao">SELECIONE CRÉDITO OU DÉBITO:
                    <option value={1}>Crédito</option>
                    <option value={2}>Débito</option>
                  </select>
                </div>
                <div className='col-4'>
                  <label htmlFor="" className='form-label'>BANDEIRA:</label>
                  <select className='form-select form-select-lg mb-3' id="inputBandeira">
                  
                    <option value={1}>VISA</option>
                    <option value={2}>MASTERCARD</option>

                  </select>
                </div>
                <div className="col-6">
                  <label htmlFor="inputCnpj" className="form-label">CNPJ DA CREDENCIADORA</label>
                  <input type="text" className="form-control" id="inputCnpj" tabIndex="1" required autoComplete="off" />
                </div>
                <div className="col-6">
                  <label htmlFor="inputAutorizacao" className="form-label">NÚMERO AUTORIZAÇÃO</label>
                  <input type="text" className="form-control" id="inputAutorizacao" tabIndex="1" />
                </div>
              </div>
            ) : null}



            <div className="row align-items-center" >
              {campoVisivel && (
              <div className="col-md-4">
                <label htmlFor="inputValorPago" className="form-label">Valor a ser pago</label>
                <NumericFormat 
                  type='text'
                  className="form-control"
                  id="inputValorPago"                  
                  defaultValue={totalComDesconto}
                  value={valorASerPago}
                  onValueChange={(values) => setValorASerPago(values.value)}
                  autoComplete="off"
                  thousandSeparator='.'
                  decimalSeparator=","
                  decimalScale={2}
                  fixedDecimalScale={true}
                  allowNegative={false}
                  prefix='R$ '
                  
                  
                />
              </div>
                       )};
              <div id='botao-pagar' className="col-md-4">
                <div className="d-flex">
                {valorRestante > 0 && (
                  <button type="button" className="btn btn-primary" onClick={registrarPagamento}>Registrar Pagamento</button>
                )}
                  {valorRestante <= 0 && (
                    <button type="submit" className="btn btn-success btn-lg mb-2 btn-block" onClick={gravaRecebimentos}>Finalizar</button>
                  )}
            </div>
            </div>
            </div>

            <br />
            
            <h3>Valor Total Pago: {valorTotalPago.toLocaleString("pt-br", { style: "currency", currency: "BRL" })}</h3>
            <h3>Valor Restante: {valorRestante.toLocaleString("pt-br", { style: "currency", currency: "BRL" })}</h3>
            <br />
            <h3>Pagamentos Realizados:</h3>
            <ul>
              {pagamentos.map((pagamento, index) => (
                <li key={index}>{pagamento.formaPagamento}: {pagamento.valor.toLocaleString("pt-br", { style: "currency", currency: "BRL" })}</li>
              ))}
            </ul>
          </div>
          <div className="modal-footer">
            {/* <button type='button' className='btn btn-danger' data-bs-dismiss='modal' onClick={mostrarCampo}>$</button> */}
            <button type="button" onClick={resetarValores} className="btn btn-danger" data-bs-dismiss="modal">Cancelar</button>
           
          </div>
        </div>
      </div>
    </div>
  

        
         
         {
           sucessoBusca ? 
           <SweetAlert
              danger                         
              confirmBtnText="OK"
              confirmBtnBsStyle="danger"
              title="algo deu errado"
              onConfirm={() => setSucessoBusca(false)}                            
            >
              Produto Não encontrado 
            </SweetAlert>:null
           
          }

{
           erroEmissao ? 
           <SweetAlert
              danger
              confirmBtnText="OK"
              confirmBtnBsStyle="danger"
              title="Erro"
              onConfirm={() => setErroEmissao(false)}                            
            >
              {msgErro}
            </SweetAlert>:null
           
          }

          {
  escolhaNota && (
    <SweetAlert
      info
      showCloseButton
      title="Emissão de Nota"
      onCancel={() => setConfirmacao(false)}
      showConfirm={false} // Oculta os botões padrão
      showCancel={false}
    >
      <p>Escolha a opção de emissão de nota fiscal:</p>
      <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '20px' }}>
        <button
          onClick={() => enviarNFce(numeroPedido, 65)}
          style={{ padding: '10px 20px', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '5px' }}
        >
          NFC-e
        </button>
        <button
          onClick={() => enviarNFce(numeroPedido, 55)}
          style={{ padding: '10px 20px', backgroundColor: '#28a745', color: '#fff', border: 'none', borderRadius: '5px' }}
        >
          NF-e
        </button>
      </div>
    </SweetAlert>
  )
}

 {
  notaCnpj && (
    <SweetAlert
      info
      showCloseButton
      title="Emissão de Nota"
      onCancel={() => setConfirmacao(false)}
      showConfirm={false} // Oculta os botões padrão
      showCancel={false}
    >
      <p>Deseja emitir nota fiscal?</p>
      <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '20px' }}>
        <button
          onClick={() => vendaSemNfce(numeroPedido)}
          style={{ padding: '10px 20px', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '5px' }}
        >
          Não
        </button>
        <button
          onClick={() => enviarNFce(numeroPedido, 55)}
          style={{ padding: '10px 20px', backgroundColor: '#28a745', color: '#fff', border: 'none', borderRadius: '5px' }}
        >
          Sim
        </button>
      </div>
    </SweetAlert>
  )
}

 {
  notaCadPadrao && (
    <SweetAlert
      info
      showCloseButton
      title="Emissão de Nota"
      onCancel={() => setConfirmacao(false)}
      showConfirm={false} // Oculta os botões padrão
      showCancel={false}
    >
      <p>Deseja emitir nota fiscal?</p>
      <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '20px' }}>
        <button
          onClick={() => vendaSemNfce(numeroPedido)}
          style={{ padding: '10px 20px', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '5px' }}
        >
          Não
        </button>
        <button
          onClick={() => enviarNFce(numeroPedido, 65)}
          style={{ padding: '10px 20px', backgroundColor: '#28a745', color: '#fff', border: 'none', borderRadius: '5px' }}
        >
          Sim
        </button>
      </div>
    </SweetAlert>
  )
}

{
           confirmacao ? 
           <SweetAlert
              warning
              showCancel
              showCloseButton
              confirmBtnText="Sim"
              confirmBtnBsStyle="danger"
              cancelBtnText="Não"
              cancelBtnBsStyle='ligth'
              title="Atenção"
              onConfirm={() =>deleteUser(confirmacaoId)}
              onCancel={() => setConfirmacao(false)}
              focusCancelBtn
              reverseButtons
            >
              Deseja excluir este Item!
            </SweetAlert>:null
           
          }

{
           erroValidacao ? 
           <SweetAlert
              danger
              confirmBtnText="OK"
              confirmBtnBsStyle="danger"
              title="Erro"
              onConfirm={() => setErrovalidacao(false)}                            
            >
              {msgErro}
            </SweetAlert>:null
           
          }

{
           confirmaEmissao ? 
           <SweetAlert
              success                         
              confirmBtnText="OK"
              confirmBtnBsStyle="success"
              title="Parabéns"
              onConfirm={() => fecharTelaVenda()}                            
            >
              Nota Emitida com sucesso!
            </SweetAlert>:null
           
          }

          {
           confirmaVenda ? 
           <SweetAlert
              success                         
              confirmBtnText="OK"
              confirmBtnBsStyle="success"
              title="Parabéns"
              onConfirm={() => fecharTelaVenda()}                            
            >
              Venda efetuada com sucesso!
            </SweetAlert>:null
           
          }

{
           confirmaPagamento ?
           <SweetAlert
              success                     
              confirmBtnText="OK"
              confirmBtnBsStyle="success"
              title="Parabéns"
              onConfirm={() =>fecharVenda()}                            
            >
              Troco a devolver: {troco.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
            </SweetAlert>:null
           
          }

             {mensagem.length > 0 ? <div className="alert alert-danger mt-2" role="alert">{mensagem}</div> : null}
             {navegar ? <Navigate to='/app/listapedidos' /> && window.location.reload()  : null}
             {sucesso === 'S' ? <Navigate to='/app/listapedidos' /> : null}

        
      </div> 

      <FooterBar/> 
   </div>
   


}


export default NovoPedido;